var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"sas-spinner",class:_vm.customSize ? '' : ("--" + _vm.size),style:({ height: _vm.customSize }),attrs:{"viewBox":"25 25 50 50","stroke":_vm.color,"stroke-width":_vm.strokeWidth}},[_c('circle')])}
var staticRenderFns = []

export { render, staticRenderFns }